import myHeader from "../../components/header.vue"
import myFooter from "../../components/footer.vue"
import {
  getCmsList
} from "../../api/service.js"
import {
  getNewsSlidshow,
  getNewsInformationList
} from "@/apiCloud/news";
import {
  pUrl
} from "@/api/baseURL.js";


export default {
  components: {
    myHeader,
    myFooter
  },
  data() {
    return {
      tabSelect: "0",
      radio1: "全部",
      activeName: "全部",
      generalNewsList: [],
      headlineNewsList: [],
      newsList: [],
      newsCategory: null,
      newsTotal: 0,
      pageSize: 10,
      pageNum: 1,
      tabsList: [{
          title: "全部"
        },
        {
          title: "站内新闻"
        },
        {
          title: "行业资讯"
        }
      ],
      isJx: false,
    }
  },
  created() {
    this.getNewsSlidshow()
    this.getNewsInformationList()
    if (localStorage.getItem("isJx") == "true") { // 是否是江西代理商访问
      this.isJx = true;
    }
    // var pUrl=window.location.href;
    // // 是否是江西代理商访问
    // if(pUrl=="http://jx.eceping.net"||pUrl.substring(0,pUrl.indexOf("/",7))=="http://jx.eceping.net"||pUrl.substring(0,pUrl.indexOf("/",7))=="http:/jx.eceping.net:8080"){//jx.eceping.net域名时,显示关于我们
    //   // console.log(1111,this.isJx)
    //   this.isJx=true;
    // }
  },
  mounted() {
    var publicCourse = document.getElementById("news")
    publicCourse.style.minHeight = document.body.scrollHeight - 90 - 257 + "px"
  },
  methods: {
    //切换tab页获取对应对应的下标
    handleClick(tab, event) {
      console.log(tab.index)
      console.log("tab", tab)
      if (tab.index != 0) {
        this.newsCategory = tab.index
      } else {
        this.newsCategory = null
      }
      this.getNewsInformationList()
    },
    //获取新闻资讯轮播图
    getNewsSlidshow() {
      let data = {}
      getNewsSlidshow(data).then(res => {
        // console.log("新闻资讯轮播图", res)
        if (res.code == 200) {
          if (res.data.generalNewsList.length > 2) {
            this.generalNewsList = res.data.generalNewsList.slice(0, 2)
          } else {
            this.generalNewsList = res.data.generalNewsList
          }
          this.headlineNewsList = res.data.headlineNewsList
        }
      })
    },
    //根据分类获取新闻
    getNewsInformationList() {
      if ($('.liContent') != undefined && $('.liContent').offset() != undefined && $('.liContent').offset().top != undefined) {
        $('html,body').animate({
          scrollTop: '610px'
        }, 500)
      }
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        newsCategory: this.newsCategory
      }
      getNewsInformationList(data).then(res => {
        // console.log("分类获取新闻", res)
        if (res.code == 200) {
          for (var i = 0; i < res.rows.length; i++) {
            var item = res.rows[i]
            // let month=item.newsReleaseTime.split("-")[1]
            // let day=item.newsReleaseTime.split("-")[2].split(" ")[0]
            let year = item.newsReleaseTime.slice(0, 4)
            let month = item.newsReleaseTime.slice(5, 7)
            let day = item.newsReleaseTime.slice(8, 10)
            console.log(month)
            item.month = month
            item.year = year
            item.day = day
            // console.log(888,item.newsReleaseTime.split("-"))
          }
          this.newsList = res.rows
          this.newsTotal = res.total
        }
      })
    },
    //切换分类获取新闻
    radioChange(val) {
      console.log(val)
      if (val == "行内资讯") {
        this.newsCategory = 2
      } else if (val == "站内新闻") {
        this.newsCategory = 1
      } else {
        this.newsCategory = null
      }
      this.getNewsInformationList()
    },
    currentChange(page) {
      this.pageNum = page
      this.getNewsInformationList()
    },
    GotoNewsDetail(id) {
      this.$router.push({
        path: "/newsDetail",
        query: {
          newsId: id,
        }
      });
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/news/news.js